import { Modal } from "react-bootstrap";
import { closeIcon } from "../../../../assets/svg";

interface profileModal {
  open: boolean;
  setOpen: (target: boolean) => void;
  title: string;
  description: string;
  setConfirmation: any;
}

const ConfirmationModal = ({
  open,
  setOpen,
  title,
  description,
  setConfirmation,
}: profileModal) => {
  const onClose = () => {
    setOpen(false);
  };
  return (
    <Modal
      show={open}
      //   centered={windowView === SCREEN_TYPE.MD_VIEW}
      className="custom-modal-profile"
      centered
    >
      <Modal.Header>
        <Modal.Title className="heading">{title}</Modal.Title>
        <div onClick={onClose}>
          <img src={closeIcon} alt="close-icon" />
        </div>
      </Modal.Header>
      <Modal.Body>
        <p>{description}</p>
        <div className="d-flex justify-content-between align-items-center">
          <button
            className="btn btn-outline-danger px-3"
            onClick={() => {
              setOpen(false);
            }}
          >
            Cancel
          </button>
          <button
            className="btn btn-success px-3"
            onClick={() => {
              setConfirmation();
              setOpen(false);
            }}
          >
            Yes
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmationModal;
